import React, { useEffect, useRef } from "react";
import { DropZone } from "@measured/puck";
import {
  focusInitialModalElement,
  trapFocusInModal,
  wireModalAriaLabel,
} from "../utils/modalAccessibility";

export function BootstrapModalDialog({
  modalId,
  modalSize = "",
  customClass = "",
  modalTitle = "",
  showModal,
  popupModalValidationAttempted,
  onClose,
}) {
  const modalRef = useRef(null);

  useEffect(() => {
    const modalEl = modalRef.current;
    if (!modalEl) {
      return undefined;
    }

    modalEl.setAttribute("role", "dialog");

    if (!showModal) {
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.removeAttribute("aria-modal");
      return undefined;
    }

    modalEl.setAttribute("aria-modal", "true");
    modalEl.setAttribute("aria-hidden", "false");
    wireModalAriaLabel(modalEl, modalId, modalTitle);
    focusInitialModalElement(modalEl);

    const handleKeyDown = (event) => trapFocusInModal(modalEl, event);
    modalEl.addEventListener("keydown", handleKeyDown);
    document.body.classList.add("modal-open");

    return () => {
      modalEl.removeEventListener("keydown", handleKeyDown);
      modalEl.setAttribute("aria-hidden", "true");
      modalEl.removeAttribute("aria-modal");
      document.body.classList.remove("modal-open");
    };
  }, [showModal, modalId, modalTitle]);

  return (
    <>
      <div
        ref={modalRef}
        className={`modal fade${showModal ? " show d-block" : ""}${customClass ? ` ${customClass}` : ""}`}
        id={modalId}
        tabIndex={-1}
        aria-labelledby={modalTitle ? `${modalId}Label` : undefined}
        aria-hidden={!showModal}
        style={showModal ? undefined : { display: "none" }}
        onClick={(e) => {
          if (e.target.id === modalId) {
            onClose();
          }
        }}
      >
        {modalTitle ? (
          <h2 id={`${modalId}Label`} className="visually-hidden">
            {modalTitle}
          </h2>
        ) : null}
        <div
          className={`modal-dialog modal-dialog-centered tco-modal-dialog p-0 ${modalSize}`}
        >
          <div className="modal-content">
            <button
              type="button"
              className="btn-close btn-close-roi"
              aria-label="Close"
              onClick={onClose}
            />
            <div
              className={`modal-body modal-body-roi-landing-form${
                popupModalValidationAttempted
                  ? " popup-modal-validation-active"
                  : ""
              }`}
            >
              <DropZone zone="wrapper" />
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal-backdrop fade show"
          onClick={onClose}
        />
      )}
    </>
  );
}
